module.exports = function () {
    $('body').on('click', '.news-landing-list__load-more-link', function (e) {
        Innophos.Pages.NewsLanding.LoadMore(this);
        return false;
    });

    $('body').on('change', '.news-landing-filters__select', function (e) {
        Innophos.Pages.NewsLanding.Search(this);
        return false;
    });
}
